import ShButton from '@/components/Helpers/ShButton';
import SmsIncomingListItem from './SmsIncomingListItem';
import SmsIncomingSearchPanel from './SmsIncomingSearchPanel';
import { hDeepCopy }  from '@/utils/helpers';
import moment from 'moment';
import EmptyList from '@/components/Common/EmptyList';
import ProgressBar from '@/components/Dashboard/ProgressBar';

// @vue/component
export default {
  name: 'SmsIncoming',

  components: {
    ShButton,
    SmsIncomingListItem,
    SmsIncomingSearchPanel,
    EmptyList,
    ProgressBar
  },

  props: {
    projectsList: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      currentPage: 1,
      itemsPerPage: 10,
      PAGE_SIZE_OPTIONS: [10, 20, 50, 100],
      filterBy: {
        from_number: '',
        to_number: '',
        is_deleted: false,
      }
      
    };
  },
  watch: {
    filterBy: {
      handler() {
        this.currentPage = 1;
      },
      deep: true,
    },
    itemsPerPage: {
      handler() {
        this.currentPage = 1;
      }
    }
  },
  
  computed: {
    isTakingNewData() {
      return this.$store.getters['global/pendingAsyncStoreActions'].includes([
        'sms/getIncomingSmsList',
      ]);
    },
    SmsIncomingList() {
      return this.$store.getters['sms/incomingList'];
    },
    SmsIncomingFilteredList() {
      let filteredIncomingList = hDeepCopy(this.SmsIncomingList.records)
      if (this.filterBy.from_number) {
        filteredIncomingList = filteredIncomingList.filter(item => item.from_number.includes(this.filterBy.from_number));
      }
      if (this.filterBy.to_number) {
        filteredIncomingList = filteredIncomingList.filter(item => item.to_number.includes(this.filterBy.to_number));
      }
      if (this.filterBy.is_deleted !== 'all') {
        filteredIncomingList = filteredIncomingList.filter(item => item.deleted === this.filterBy.is_deleted);
      }
      return filteredIncomingList;
    },
    incomingItemsToRenderPerPage() {
      return this.SmsIncomingFilteredList.slice((this.currentPage - 1) * this.itemsPerPage, this.currentPage * this.itemsPerPage)
    },
    isEmpty() {
      return this.SmsIncomingList.total === 0;
    },
    isLoading() {
      return this.$store.getters['global/pendingAsyncStoreActions'].includes([
        'sms/getSmsIncomingList',
      ]);
    },
    isSinglePage() {
      return this.SmsIncomingFilteredList.length <= this.itemsPerPage;
    },
    isDisabled() {
      return this.$store.getters['global/pendingAsyncStoreActions'].includes(['sms/getRefreshAllSmsStatus'])
    }
  },


  methods: {
    async getIncomingSmsList() {
      await this.$store.dispatch('sms/getIncomingSmsList');
    },
    changeFilterBy(value) {
      this.filterBy = value
    },
    handleChangePage(page) {
      this.currentPage = page;
    },
    async fetchIncomingSms() {
      await this.$store.dispatch('sms/getIncomingSmsList');
    }
},
  async created() {
    await this.$store.dispatch('sms/getIncomingSmsList');
    this.$store.dispatch('sms/getSmsHeadersList');
  }
};
